import axios from 'axios'

const API_PREFIX = "/auth"

export const apiAuthProfile = () => {
    return axios.get(`${API_PREFIX}/profile`)
}

export const apiBrazeExternalID = (userID) => {
    return axios.get(`${API_PREFIX}/braze/${userID}`)
}

export const apiAuthRefeshToken = (userID) => {
    return axios.get(`${API_PREFIX}/refresh?uid=${userID}`)
}

export const apiRemoveAccessToken = () => {
    return axios.get(`${API_PREFIX}/invalid`)
}
